import { useEffect, useState } from 'react'

import { formatMoney } from 'services/util'
import css from '../items/sass/itembid.module.scss'
import themeCss from '../components/sass/theme.module.scss'

export default function DonationSelector({ donation, setDonation, auctionDetail }) {

  const [amounts, setAmounts] = useState([])

  useEffect(() => {

    if (!auctionDetail) return

    let result = [
      auctionDetail.LowDonationAmount,
      auctionDetail.MidDonationAmount,
      auctionDetail.HighDonationAmount
    ]

    if (!donation) setDonation(result[1])

    setAmounts(result)

  }, [auctionDetail])

  const isAmountActive = (value) => {
    if (value === donation) return 'bid-value-active'
    else return 'bid-value-inactive'
  }

  // if (!donation) return <></>

  return (
    <>      
      <div className={css['bid-selectors']}>
        {amounts && amounts.map((amount) => {
          return <div key={amount} className={`${css[isAmountActive(amount)]} ${themeCss['shadowed']}`} onClick={() => setDonation(amount)}>{`$${formatMoney(amount)}`}</div>
        })}
      </div>
    </>
  )
}